const AllPayslip = () => import("./views/AllPayslip.vue");
const LoanRequestForm = () => import("./views/LoanRequestForm.vue");
const AllLoanApproval = () => import("./views/AllLoanApproval.vue");
const GeneratePayslip = () => import("./views/GeneratePayslip.vue");
const PayslipPreview = () => import("./views/PayslipPreview.vue");

export default [
  {
    path: "",
    redirect: "/ess/payroll/payslip/view-all",
  },
  {
    name: "view-my-payslip",
    path: "view-all",
    component: AllPayslip,
  },
  {
    name: "view-all-payslip",
    path: "allowance/view-all",
    component: AllLoanApproval,
  },
  {
    name: "generate-payslip",
    path: "generate-payslip",
    component: GeneratePayslip,
  },
  {
    name: "preview-payslip",
    path: "preview-payslip",
    component: PayslipPreview,
  },
  {
    name: "create-my-loan-request",
    path: "create",
    component: LoanRequestForm,
  },
  {
    name: "edit-my-payslip",
    path: "edit/:id",
    component: LoanRequestForm,
  },
  {
    name: "view-my-payslips",
    path: "approval/view-all",
    component: AllLoanApproval,
  },
];
